import React, { useState } from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { Capacity, CapacityPicker } from "../../../../forms/capacityPicker/capacityPicker";
import styles from "../filterStyles.css";
import { useFilterWrapper } from "../listFilterWrapper/useFilterWrapper";
import { useSettingsListFilters } from "../useListFilter/useListFilter";
import { FilterLabel } from "./filterLabel";

const filterId = "CapacityFilter";

interface Props<T> {
  predicate: (pickedCapacity: number) => (item: T) => boolean;
  itemsProvider: () => Capacity[];
}
export const CapacityFilter = <T extends unknown>({ predicate, itemsProvider }: Props<T>) => {
  const [isPicking, setIsPicking] = useState(false);

  const { activeFilters, deactivateFilter } = useSettingsListFilters<T>();
  const { selectedFilters, selectFilter, deselectFilter } = useFilterWrapper<T>();

  const activated = selectedFilters[filterId] || activeFilters[filterId];

  const handleClick = () => {
    if (activated) {
      if (!!activeFilters[filterId]) {
        deactivateFilter(filterId);
      }
      if (!!selectedFilters[filterId]) {
        deselectFilter(filterId);
      }
    } else {
      setIsPicking(true);
    }
  };

  const handleCapacityPicked = (newCapacity: Capacity) => {
    selectFilter({
      predicate: predicate(newCapacity?.value || 0),
      description: intl.formatMessage("settings.filters.capacity"),
      content: newCapacity.name,
      filterId
    });
    setIsPicking(false);
  };

  return (
    <>
      {isPicking ? (
        <CapacityPicker
          onOutsideClick={() => setIsPicking(false)}
          className={styles.picker}
          onChange={handleCapacityPicked}
          itemsProvider={itemsProvider}
          initialIsOpen
        />
      ) : (
        <FilterLabel
          active={!!activated}
          text={intl.formatMessage("settings.filters.capacity")}
          content={activated?.content}
          onClick={handleClick}
        />
      )}
    </>
  );
};
